import { render, staticRenderFns } from "./Icrea.vue?vue&type=template&id=63fd6248&"
import script from "./Icrea.vue?vue&type=script&lang=js&"
export * from "./Icrea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports